import FloatingBtn from "./FloatingBtn.presenter";

export default FloatingBtn;
